import React from "react";
import styled from "styled-components";

import { CheckIcon } from "src/static/icons";

interface CalendarFilterPillProps {
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

/** Toggle chip used on the calendar day-jump row (My shifts / Available). */
export const CalendarFilterPill: React.FC<CalendarFilterPillProps> = ({
  active,
  disabled = false,
  onClick,
  children,
}) => (
  <PillButton
    type="button"
    active={active}
    disabled={disabled}
    aria-pressed={active}
    aria-disabled={disabled}
    onClick={onClick}
  >
    {active && <PillCheckIcon />}
    {children}
  </PillButton>
);

const PillButton = styled.button<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  flex: none;
  gap: 6px;
  border: none;
  border-radius: 27.568px;
  padding: 4px 14px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  background: ${({ theme, active }) =>
    active
      ? theme.globalConstants.color.brandPrimary
      : theme.globalConstants.color.backgroundGrayDark};
  color: ${({ theme, active }) =>
    active
      ? theme.globalConstants.color.white
      : theme.globalConstants.color.textSecondary};

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.globalConstants.color.borderFocus};
    outline-offset: 1px;
  }
`;

const PillCheckIcon = styled(CheckIcon)`
  width: 14px;
  height: 14px;
`;

export default CalendarFilterPill;
